import { createContext, useCallback, useContext, useEffect, useMemo } from "react";

const ThemeContext = createContext({
    theme: "dark",
    setTheme: () => {},
    toggleTheme: () => {},
});

const STORAGE_KEY = "pranto-gfx-theme";

const applyTheme = (theme) => {
    const root = document.documentElement;
    if (theme === "dark") {
        root.classList.add("dark");
        root.style.colorScheme = "dark";
    } else {
        root.classList.remove("dark");
        root.style.colorScheme = "light";
    }
    const themeColor = theme === "dark" ? "#050B0C" : "#FFFFFF";
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
    }
    meta.content = themeColor;
};

export const ThemeProvider = ({ children }) => {
    // Site is locked to the cinematic dark theme (light mode retired per direction).
    const theme = "dark";

    useEffect(() => {
        applyTheme("dark");
        try {
            window.localStorage.setItem(STORAGE_KEY, "dark");
        } catch (_e) { /* ignore */ }
    }, []);

    const setTheme = useCallback(() => {}, []);
    const toggleTheme = useCallback(() => {}, []);

    const value = useMemo(() => ({ theme, setTheme, toggleTheme }), [setTheme, toggleTheme]);
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
